import { useCallback, useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { portalOf } from '../contexts/MarketContext';
import { PIPELINE_SETTINGS_DOC, getCategoryStages } from '../utils/statuses';

/**
 * Live per-portal status pipeline checklists (settings/statusPipeline).
 * Returns `stagesFor(categoryKey, tourDoc)` — the checklist that tour's portal
 * uses for that category, falling back to the defaults in statuses.js.
 */
export default function useStatusPipeline() {
  const [config, setConfig] = useState(null);

  useEffect(() => onSnapshot(
    doc(db, ...PIPELINE_SETTINGS_DOC),
    (snap) => setConfig(snap.exists() ? snap.data() : {}),
    () => setConfig({}),
  ), []);

  const stagesFor = useCallback(
    (categoryKey, tour) => getCategoryStages(categoryKey, config, portalOf(tour)),
    [config],
  );

  return { stagesFor, config, loaded: config !== null };
}
